import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import FieldRowWithTextInput from './FieldRowWithTextInput'
import FieldRowWithAudience from './FieldRowWithAudience'
import { 
  queryGetEmailCampaignAccount, 
  mutationCreateCampaign,
  mutationCreateCampaignAsDraft,
  mutationEditDraft
} from 'Apollo'
import { graphql, compose } from "react-apollo";
import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs'
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import './editor.css'
import LoadingPanel from "module-common/LoadingPanel";
import { queryGetSingleCampaign } from "../../Apollo";

export default compose(    
    graphql(queryGetEmailCampaignAccount, {
        name: 'account'
    }),
    graphql(mutationCreateCampaign, {
        name: 'mutateCreateCampaign',
        refetchQueries: ['getEmailCampaign']
    }),
    graphql(mutationCreateCampaignAsDraft, {
      name: 'mutateCreateDraft',
      refetchQueries: ['getEmailCampaign']
    }),
    graphql(mutationEditDraft, {
      name: 'editDraft',
      refetchQueries: ['getEmailCampaign']
    }),
    graphql(queryGetSingleCampaign, {
      name: 'campaignDraft',
      skip: props => !props.isDraft,
      options: {
        fetchPolicy: 'network-only'
      }
    })
)(
    class CreateCampaign extends Component {

        state = {
            subject: this.props.subject || '',
            title: this.props.title || '',
            preview: this.props.preview || '',
            fromName: this.props.fromName || '',
            replyTo: this.props.replyTo || '',
            body: '',
            audienceId: null,
            isSending: false,
            editorState: EditorState.createEmpty()
        }

        textFields = [
            {
                label: 'Campaign Name',
                stateName: 'subject'
            },
            {
                label: 'Title',
                stateName: 'title'
            },
            {
                label: 'Preview',
                stateName: 'preview'
            },
            {
                label: 'From',
                stateName: 'fromName'
            },
            {
                label: 'Reply To',
                stateName: 'replyTo'
            }
        ]

        componentWillReceiveProps(nextProps) {
            const { account: { loading, getEmailCampaignAccount }, campaignDraft: { getCampaign } = {}  } = nextProps;
            if(getEmailCampaignAccount) {
                this.setState(state => ({
                  ...state, 
                  replyTo: getEmailCampaignAccount.email, 
                  accountId: getEmailCampaignAccount.id 
                }))
            }
            if(getCampaign && getCampaign.emailTemplate.htmlBody) {
              const blocksFromHtml = htmlToDraft(getCampaign.emailTemplate.htmlBody);
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const newState = EditorState.createWithContent(contentState);
              this.setState(state => ({
                ...state,
                editorState: newState
              }))
            }
        }

        onCreate = async () => {
            const { onSuccess, campaignId } = this.props
            const {
                audienceId,
                accountId,
                subject,
                fromName,
                title,
                replyTo,
                preview,
                editorState
            } = this.state
            const body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
            if((accountId && audienceId && subject && fromName && title && replyTo && preview && body)) {
                
                try {
                    this.setState(state => ({...state, isSending: true}))
                    if(!campaignId) {
                      const result = await this.props.mutateCreateCampaign({
                          variables: {
                              accountId, 
                              audienceId, 
                              subject,
                              title,
                              preview,
                              fromName,
                              replyTo,
                              toName: '',
                              html: body
                          },
                          refetchQueries: ['queryGetEmailCampaign', 'getEmailCampaign']
                      })
                    } else {
                      const result = await this.props.editDraft({
                        variables: {
                          accountId, 
                          campaignId, 
                          subject,
                          title,
                          preview,
                          fromName,
                          replyTo,
                          toName: '',
                          html: body,
                          triggerSend: true  
                        },
                        refetchQueries: ['queryGetEmailCampaign', 'getEmailCampaign']
                      })  
                    }
                    this.flushPanelData()
                    if(onSuccess) onSuccess()
                } catch(e) {
                    console.log("Error on creating campaign!", e)
                }
            } else {
                //show notice here
                console.log("Please fill all field!")
            }            
        }

        onSaveAsDraft = async () => {
          const { onSuccess, campaignId } = this.props
          const {
              audienceId,
              accountId,
              subject,
              fromName,
              title,
              replyTo,
              preview,
              editorState
          } = this.state
          const body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
          if((accountId && audienceId && subject && fromName && title && replyTo && preview && body)) {
              try {
                  this.setState(state => ({...state, isSending: true}))
                  if(!campaignId) {
                    const result = await this.props.mutateCreateDraft({
                      variables: {
                          accountId, 
                          audienceId, 
                          subject,
                          title,
                          preview,
                          fromName,
                          replyTo,
                          toName: '',
                          html: body
                      },
                      refetchQueries: ['queryGetEmailCampaign', 'getEmailCampaign']
                  })
                  } else {
                    const result = await this.props.editDraft({
                      variables: {
                        accountId, 
                        campaignId, 
                        subject,
                        title,
                        preview,
                        fromName,
                        replyTo,
                        toName: '',
                        html: body,
                        triggerSend: false  
                      },
                      refetchQueries: ['queryGetEmailCampaign', 'getEmailCampaign']
                    })
                  }
                  
                  this.flushPanelData()
                  if(onSuccess) onSuccess()
              } catch(e) {
                  console.log("Error on creating campaign!", e)
              }
          } else {
              //show notice here
              console.log("Please fill all field!")
          }            
      }

        flushPanelData = () => {
            this.setState(state => ({
                ...state,
                subject: '',
                title: '',
                preview: '',
                fromName: '',
                replyTo: '',
                body: '',
                audienceId: null,
                isSending: false,
                editorState: EditorState.createEmpty()
            }))
        }

        render() {
            const { campaignDraft } = this.props
            const { isSending, editorState } = this.state
            console.log(this.props)
            return (    
            <WrapperPost>
                {isSending && <Overlay>
                    <LoadingPanel />
                </Overlay>}
                <Wrap>
                    <LeftColumn>
                        <FieldRowWithAudience label="Audience" onChange={(audience) => {
                            this.setState(state => ({
                                ...state,
                                fromName: audience.campaignDefaults.fromName,
                                replyTo: audience.campaignDefaults.fromEmail,
                                subject: audience.campaignDefaults.subject,
                                audienceId: audience.id
                            }))
                        }} />
                        {this.textFields.map(({ label, stateName }) => {
                            return <FieldRowWithTextInput 
                                key={label}
                                label={label}
                                value={this.state[stateName]}
                                onChange={text => this.setState(state => ({...state, [stateName]: text }))}
                            />
                        })}
                    </LeftColumn>
                    <RightColumn>
                        <Editor 
                            editorState={editorState}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={editorState => this.setState(state => ({...state, editorState }))}
                        />
                    </RightColumn>
                </Wrap>
                <Bottom>
                    <LeftBottom></LeftBottom>
                    <RightBottom>
                        <SendButton onClick={() => this.onCreate() } >Send</SendButton>
                        <SendButton onClick={() => this.onSaveAsDraft() } >Save as Draft</SendButton>
                    </RightBottom>
                </Bottom>
            </WrapperPost>
            );
        }
    }
)


const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;

const Overlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: gray;
  opacity: 0.2;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin: 5px 20px 10px;
  height: calc(70vh);
  position: relative;
`;
const WrapperSchedule = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const Border = styled.div`
  display: flex;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${props => props.theme.panelBackground};
  box-shadow: ${props => props.theme.shadow};
  margin: 10px;
  flex-direction: column;
  ${props => props.width && css`width: ${props.width};`}
`;
const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;


const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;

const Wrap = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  /* border-top: 1px solid ${props => props.theme.panelBorder}; */
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 45%;
  align-items: center;
  padding: 3px 20px 3px 20px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 10px 10px 0 10px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/campaign/CreateCampaignWithQueryMutation.js